import React, { useEffect, useState } from "react";
import { ReactComponent as SearchIcon } from "../../../assets/icons/filter/search.svg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/warehouse/check.svg";
import { ReactComponent as UncheckIcon } from "../../../assets/icons/warehouse/uncheck.svg";

import { ISelectsInput } from "../../../types/selects.type";
import { filterSelectItems } from "../../../utils/filterUsers";
import EditInput from "../../modals/forms/inputs/EditInput/EditInput";
import styles from "./styles.module.scss";

interface Props {
  items: ISelectsInput[];
  title: string;
  isMultiSelect?: boolean;
  value?: ISelectsInput | null;
  values?: ISelectsInput[];
  onClickInactive: (value: ISelectsInput) => void;
  onClickActive: (value: ISelectsInput) => void;
}

const SelectChangeListInput: React.FC<Props> = (props) => {
  const [search, setSearch] = useState<string>("");
  const [itemsList, setItemsList] = useState<ISelectsInput[]>(props.items);

  const onChangeSearch = () => {
    if (!search) {
      setItemsList(props.items);
      return;
    }
    setItemsList(filterSelectItems(props.items, search));
  };

  useEffect(() => {
    onChangeSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    <div className={styles.container}>
      <EditInput
        value={search}
        isRequired={false}
        setValue={(value) => setSearch(value)}
      >
        <SearchIcon />
      </EditInput>
      <div className={styles.buttonsContainer}>
        {itemsList.map((item) => {
          if (
            props.isMultiSelect
              ? props.values?.some((list) => list.id === item.id)
              : item.id === props.value?.id
          ) {
            return (
              <button
                key={item.id}
                className={`${styles.button} ${styles.active}`}
                type="button"
                onClick={() => props.onClickActive(item)}
              >
                <CheckIcon />
                <span className={styles.titleContainer}>
                  <span>{item.name}</span>
                  <span className={styles.subTitleContainer}>
                    {item.subName && (
                      <span className={styles.subTitle}>{item.subName}</span>
                    )}
                    {item.secondSubName && (
                      <span className={styles.subTitle}>
                        / {item.secondSubName}
                      </span>
                    )}
                  </span>
                </span>
              </button>
            );
          } else {
            return (
              <button
                key={item.id}
                className={`${styles.button} ${styles.inactive}`}
                type="button"
                onClick={() => props.onClickInactive(item)}
              >
                <UncheckIcon />
                <span className={styles.titleContainer}>
                  <span>{item.name}</span>
                  <span className={styles.subTitleContainer}>
                    {item.subName && (
                      <span className={styles.subTitle}>{item.subName}</span>
                    )}
                    {item.secondSubName && (
                      <span className={styles.subTitle}>
                        / {item.secondSubName}
                      </span>
                    )}
                  </span>
                </span>
              </button>
            );
          }
        })}
      </div>
    </div>
  );
};

export default SelectChangeListInput;
